import React, { useRef } from 'react';

import { Box } from '@mui/material';

import StyledTypography from '../../../../../../shared/components/styled-typography/styled-typography';
import { useGetSearchTerm } from '../../../../../../shared/hooks/use-get-search-term/use-get-search-term.hook';
import { REVIEWS } from '../../../../../../store/utils/files-names';
import SearchBar from '../../../../../shared/components/search-bar/SearchBar';
import { useClearText } from '../../../../../shared/components/search-bar/hooks/use-clear-text/use-clear-text.hook';
import SetIsCheckedContextProvider from '../../../../../shared/components/ui/Table/components/table/context/set-is-checked/set-is-checked.context';
import { useInputHandlerEvent } from '../../../../../shared/hooks/use-input-event-handler/use-input-event-handler.hook';
import { useSearchHandlerEvent } from '../../../../../shared/hooks/use-search-event-handler/use-search-event-handler.hook';
import { useToggleFiltersVisibility } from '../../../../../shared/hooks/use-toggle-filters-visibility/use-toggle-filters-visibility.hook';
import { useAreReviewsFiltersVisible } from '../../hooks/use-are-reviews-filters-visible/use-are-reviews-filters-visible.hook';
import {
  filterReviewsByAuthorAndReview,
  reviewsToggleFiltersVisibility,
} from '../../store/slices/slices/reviews.slice';
import { getReviews } from '../../thunks/get-reviews.thunk';
import { ReviewsFilters } from '../../thunks/models/reviews-filters.model';
import ReviewStatistics from '../review-statistics/review-statistics';
import ReviewFiltersContainer from '../reviews-filters/review-filters-container';
import { ReviewsTable } from '../reviews-table/reviews-table';

export const RatingsAndReviews = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const clearText = useClearText(
    inputRef,
    filterReviewsByAuthorAndReview,
    'search'
  );
  const reviewsSearchTerm = useGetSearchTerm(REVIEWS, 'search');
  const areFiltersVisible = useAreReviewsFiltersVisible();
  const toggleFiltersVisibility = useToggleFiltersVisibility(
    reviewsToggleFiltersVisibility
  );

  const handleInputEvent = useInputHandlerEvent<ReviewsFilters>(
    'search',
    filterReviewsByAuthorAndReview
  );

  const handleSearchEvent = useSearchHandlerEvent(getReviews, REVIEWS);

  return (
    <Box data-testid="ratings-and-reviews">
      <SetIsCheckedContextProvider>
        <ReviewStatistics />
        <StyledTypography variant="h1">Reviews</StyledTypography>
        <SearchBar
          searchInputPlaceholder="Author and Review"
          filterButtonClickHandler={toggleFiltersVisibility}
          searchInputChangeHandler={handleInputEvent}
          searchOnSubmitHandler={handleSearchEvent}
          inputRef={inputRef}
          clearText={clearText}
          areFiltersVisible={areFiltersVisible}
          initialValue={reviewsSearchTerm}
        />
        {areFiltersVisible && <ReviewFiltersContainer />}
        <ReviewsTable />
      </SetIsCheckedContextProvider>
    </Box>
  );
};
